var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCircleShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 52.4986,
    cy: 69.5015,
    r: 47.1607,
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.4991,
    cy: 69.5002,
    r: 56.5929,
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 69.5,
    r: 69.5,
    fill: "white",
    fillOpacity: 0.04
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8447_45051)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M49.8386 28.9077C51.5972 27.6974 54.0323 27.6974 55.7909 28.9077L81.4942 42.0869V91.1726H61.3374L48.7563 110V95.3415L57.0084 83.1037H73.3774V47.1972L52.8147 36.7077L32.2521 47.1972V83.1037H48.621V91.3071H24V42.2214L49.8386 28.9077Z",
    fill: "#8E849D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8447_45051",
    x: 12.7152,
    y: 26.8119,
    width: 79.9133,
    height: 88.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.78218
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.48515
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.294118 0 0 0 0 0.305882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8447_45051"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8447_45051",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircleShadow);
export default __webpack_public_path__ + "static/media/logo-circle-shadow.528f81a26bcc3310a7d42f855b791ccc.svg";
export { ForwardRef as ReactComponent };